import { render, staticRenderFns } from "./shujiDetail.vue?vue&type=template&id=5ca8684c&"
import script from "./shujiDetail.vue?vue&type=script&lang=js&"
export * from "./shujiDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports